import React, { Component } from 'react'

import withCssClassName from '../with-css-class-name'

class ErrorIcon extends Component {
    render() {
        return (
            <svg {...this.props} height="15" viewBox="0 0 16 15" width="16" xmlns="http://www.w3.org/2000/svg"><path d="M1.655 15C-.02 15-.301 14.08.268 13.01L7.122.527A1 1 0 0 1 7.53.12C7.596.084 7.753.044 8 0c.214.026.37.066.47.12a1 1 0 0 1 .408.407l6.854 12.483c.57 1.07.287 1.99-1.387 1.99H1.655zm5.34-10.007v5.014h2.002V4.993H6.996zm0 6.015v1.99h2.002v-1.99H6.996z"/></svg>
        )
    }
}

export default withCssClassName(ErrorIcon)



// WEBPACK FOOTER //
// src/components/svg-icon/icons/error-icon.js